import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
    TgIconBasicWarningFramedModule,
    TgIconBasicTickFramedModule,
    TgIconBasicInfoFramedModule,
    TgIconLightbulbModule,
    TgButtons2Module,
    TgBoxes2Module
} from '@trademe/tangram';

import { NotificationsComponent } from './notifications.component';
import { DelayService } from '@trademe/tangram';

@NgModule({
    imports: [
        CommonModule,
        TgIconBasicInfoFramedModule,
        TgIconBasicTickFramedModule,
        TgIconBasicWarningFramedModule,
        TgIconLightbulbModule,
        TgButtons2Module,
        TgBoxes2Module
    ],
    declarations: [NotificationsComponent],
    exports: [NotificationsComponent],
    providers: [DelayService]
})
export class NotificationsModule {}
